<template>
  <div class="timeline">
    <div
      v-for="(item, index) in timeline.items"
      :key="`timelineitem_${index}`"
      class="timeline-box"
      :class="{
        'timeline-box-content-left': (index + timeline.left) % 2 !== 0,
        'timeline-box-content-right': (index + timeline.left) % 2 === 0
      }"
    >
      <div class="timeline-left">
        <div class="timeline-date" v-if="(index + timeline.left) % 2 === 0">
          {{ item.date }}
        </div>

        <div
          class="card grey lighten-5"
          v-if="(index + timeline.left) % 2 !== 0"
        >
          <div class="card-content">
            <span class="card-title col-header">
              <span class="xs-date-holder">{{ item.date }}</span>
              {{ item.headline }}
            </span>
            <!-- compile raw HTML into p tag -->
            <p
              v-for="(content, contentIndex) in item.content"
              :key="`contentIndex_0_${contentIndex}`"
              v-html="content"
            ></p>
          </div>
        </div>
        <!-- .card -->
      </div>

      <div class="timeline-icon">
        <i class="material-icons medium">{{ item.icon }}</i>
      </div>

      <div class="timeline-right">
        <div class="timeline-date" v-if="(index + timeline.left) % 2 !== 0">
          {{ item.date }}
        </div>

        <div
          class="card grey lighten-5"
          v-if="(index + timeline.left) % 2 === 0"
        >
          <div class="card-content">
            <span class="card-title col-header">
              <span class="xs-date-holder">{{ item.date }}</span>
              {{ item.headline }}
            </span>
            <!-- compile raw HTML into p tag -->
            <p
              v-for="(content, contentIndex) in item.content"
              :key="`contentIndex_1_${contentIndex}`"
              v-html="content"
            ></p>
          </div>
        </div>
        <!-- .card -->
      </div>
    </div>
    <!-- .timeline-box -->
  </div>
</template>

<script>
export default {
  name: "timeline",

  data() {
    return {};
  },

  props: {
    timeline: {
      type: Object,
      default() {
        return {
          title: "Timeline",
          left: 0, // 0 = first Content-Box right direction, 1 = first Content-Box left direction

          items: [
            {
              date: "",
              icon: "",
              headline: "",
              content: [""]
            }
          ]
        };
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
